import HomeIcon from "@mui/icons-material/Home";
import Home from "../../pages/Home";
import { InternalAndGuestUserRoles } from "../../constants/roles";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: Home,
  allowedRoles: InternalAndGuestUserRoles,
  label: "Home",
  icon: () => <HomeIcon />,
  isCustomIcon: false,
  hasDivider: false,
};

export const homeRoutes: { [key: string]: RouteConfig } = {
  home: baseRoute,
};
